import { render, staticRenderFns } from "./TravelFeature.vue?vue&type=template&id=1d0a76f6&scoped=true&"
import script from "./TravelFeature.vue?vue&type=script&lang=js&"
export * from "./TravelFeature.vue?vue&type=script&lang=js&"
import style0 from "./TravelFeature.vue?vue&type=style&index=0&id=1d0a76f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a76f6",
  null
  
)

export default component.exports